import { createContext, useContext } from 'react'
import { Survey as SurveyType } from '@/features/surveys/classes/SurveyModel'
import { SurveyDemographicOption } from '@/features/surveys/classes/SurveyDemographicOptionModel'

export type SurveyPreviewContextType = {
  survey: SurveyType
  demographicOptions: SurveyDemographicOption[]
}

export const SurveyPreviewContext = createContext<SurveyPreviewContextType | null>(
  null,
)

export const useSurveyPreview = () => {
  const context = useContext(SurveyPreviewContext)
  if (!context) {
    throw new Error('useSurveyPreview must be used within SurveyPreviewProvider')
  }
  return context
}
